import { config } from '_config';
import { authHeader } from '_helpers';

export const userService = {
    login,
    logout,
    register,
    activate,
    resetPassword,
    setPassword,
    submitStripe,
    getAll,
    getById,
    getByEmail,
    getOwn,
    update,
    updateNoOrg,
    delete: _delete,
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
    };

    return fetch(`${config.baseUrl}/api-token-auth/`, requestOptions)
        .then(handleResponse)
        .then((user) => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function update(user) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user),
    };

    return fetch(`${config.apiUrl}/users/update_self_order/`, requestOptions).then(handleResponse);
}

function updateNoOrg(user) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user),
    };

    return fetch(`${config.apiUrl}/users/update_self/`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/users/`, requestOptions).then(handleResponse);
}

function getOwn() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/users/own/`, requestOptions)
        .then(handleResponse)
        .then((user) => {
            // login successful if there's a jwt token in the response
            if (user.is_staff) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('perm', 5);
            }
            return user;
        });
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/users/${id}/`, requestOptions).then(handleResponse);
}

function getByEmail(email) {
    const requestOptions = {
        method: 'GET',
    };

    return fetch(`${config.apiUrl}/users/?email=${email}`, requestOptions).then(handleResponse);
}

function register(values) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
    };

    return fetch(`${config.baseUrl}/register/`, requestOptions).then(handleResponse);
}

function resetPassword(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(email),
    };

    return fetch(`${config.baseUrl}/reset_password/`, requestOptions).then(handleResponse);
}

function setPassword(values) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
    };

    return fetch(`${config.baseUrl}/set_password/`, requestOptions).then(handleResponse);
}

function activate(token) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(token),
    };

    return fetch(`${config.baseUrl}/activate/`, requestOptions).then(handleResponse);
}

function submitStripe(stripeToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({stripe_token: stripeToken}),
    };

    return fetch(`${config.apiUrl}/users/submit_stripe/`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/users/${id}/`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js